import React from "react";

const DisplayInput = ({ input: { value } }) => <span>{value}</span>;

export default DisplayInput;
